<template>
<div class="wrap">
  <Tabs2 :data="['基础属性', '表单操作权限']"
  @on-tab="handleTab"
  :height="40"
  :tab="tab" />

  <BaseInfo v-if="tab === 0" :item="item" @on-item="handleBaseInfo" />

  <FormList v-if="tab === 1" :datas="fromPropertyList" @on-list="handleFormList" />

</div>
</template>

<script>
import { mixinFormProperty, mixinTabs } from '../mixins'
import FormList from './FormList'
export default {
  mixins: [mixinFormProperty, mixinTabs],
  components: {
    FormList
  },
  data() {
    return {

    }
  },
  watch: {
    item(val, oldVal) {
      if (val?.properties?.fromPropertyList) {
        this.fromPropertyList = val.properties.fromPropertyList
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./pop.scss";
</style>
